import { render, staticRenderFns } from "./PbcIcon.vue?vue&type=template&id=678f404e&functional=true&"
import script from "./PbcIcon.vue?vue&type=script&lang=js&"
export * from "./PbcIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports